import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { ContentPreview } from '../../../../../ContentPreview'
import { GetContentByIDV2Return } from '../../../../helpers/types'
import { validations } from '../../../../helpers/validations'
import { TwitterStreamFooter } from '../../../sharedDisplays/footers/TwitterStreamFooter'
import { TwitterStreamHeader } from '../../../sharedDisplays/headers/TwitterStreamHeader'
import { sharedStyles } from '../shared/styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  display: string
  getContentByIdV2?: (id: number) => Promise<GetContentByIDV2Return>
  index: number
  isAccountPremium?: boolean
  isPresenting: boolean
  isSnapshot: boolean
  isThreaded: boolean
  modulesLength?: number
  onContentChange: (val: string) => void
  onRefreshChange: (val: string, dest: string) => void
  onRetweetUrlChange: (val: string, dest: string) => void
  onSnapshotUrlChange: (val: string, dest: string) => void
  postType: string
  readOnly: boolean
  refreshedAt: string
  retweetUrl: string
  snapshotUrl: string
}

export const Stream: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  display = 'mobileStream',
  getContentByIdV2,
  index,
  isAccountPremium,
  isPresenting,
  isThreaded,
  modulesLength,
  onContentChange,
  onRefreshChange,
  onRetweetUrlChange,
  onSnapshotUrlChange,
  postType,
  readOnly,
  refreshedAt,
  retweetUrl,
  snapshotUrl,
}) => (
  <Fragment>
    <TwitterStreamHeader
      accountImage={accountImage}
      accountName={accountName}
      accountUsername={accountUsername}
      content={content}
      isAccountPremium={isAccountPremium}
      modulesLength={modulesLength}
      isThreaded={isThreaded}
      postType={postType}
      index={index}
      isMobile={display.includes('mobile')}
      onContentChange={onContentChange}
      readOnly={readOnly}
    />
    <div css={sharedStyles.getRetweetWrapper(true)}>
      <ContentPreview
        embeddedUrl={retweetUrl}
        embeddedUrlRegex={validations.twitterUrlValidation}
        snapshotUrl={snapshotUrl}
        refreshedAt={refreshedAt}
        isPresenting={isPresenting}
        readOnly={readOnly}
        getContentByIdV2={getContentByIdV2}
        onRefreshChange={(val: string) => onRefreshChange(val, 'refreshed_at')}
        onEmbeddedUrlChange={(val: string) =>
          onRetweetUrlChange(val, 'retweet_url')
        }
        onSnapshotUrlChange={(val: string) =>
          onSnapshotUrlChange(val, 'snapshot_url')
        }
        display={display}
      />
    </div>
    <TwitterStreamFooter isMobile={display.includes('mobile')} />
  </Fragment>
)
